export const isStorageItem = key => {
  let item = localStorage.getItem(key);
  return item && JSON.parse(item);
};
